import { Loader } from "google-maps";

(function () {
  const loader = new Loader("AIzaSyA0KPtWDcb08Tc5RK7jB8iD7O8BQHhQpaQ");
  loader.load().then((google) => {
    document.querySelectorAll(".js-gmap").forEach((elem) => {
      const location = {
        lat: parseFloat(elem.dataset.lat),
        lng: parseFloat(elem.dataset.lng),
      };
      const map = new google.maps.Map(elem, {
        zoom: 13,
        center: location,
      });

      const image = "/wp-content/themes/ice-cream-farm/img/map-marker.png";
      new google.maps.Marker({
        position: location,
        map: map,
        icon: image,
      });
    });
  });
})();
